import type { CSSProperties, FC, ReactElement } from "react"

import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

import { dividerConfig as config } from "./divider.config"
import { EDividerColor as EVariant } from "./divider.types"

type TProps = {
    className?: string
    variant?: EVariant
    margins?: { top?: CSSProperties["marginTop"]; bottom?: CSSProperties["marginBottom"] }
    height?: 0.5 | 1
    width?: string
}

const classes = { divider: "border-none mx-auto" }

const Divider: FC<TProps> = ({
    className = String(""),
    variant = EVariant.DarkBlue,
    margins = { top: "0px", bottom: "0px" },
    height = 1,
    width = "100%"
}: TProps): ReactElement => (
    <hr
        style={{
            marginTop: margins.top,
            marginBottom: margins.bottom,
            height: `${height}px`,
            width
        }}
        className={buildCssClassName(
            classes.divider,
            { [config.colorsMap[variant]]: variant },
            { [className]: className },
            getTransitionTwClasses("colors", 100)
        )}
    />
)

export { Divider }
